var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Nuxt',{staticClass:"relative"}),_vm._v(" "),_c('MainAudioPlayer',{staticClass:"z-20"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }